import React, {useEffect, useState} from "../../_snowpack/pkg/react.js";
import "./Ehr.css";
import * as swm from "../../_snowpack/pkg/swm-client-lib.js";
const demoHandle = "RXhhbXBsZSBoYW5kbGUK";
const demoAppUrl = "https://barabo.github.io/swm-dd-demo/app/";
const defaultAppUrl = localStorage.getItem("ehr/appUrl") || demoAppUrl;
const defaultAppOrigin = new URL(defaultAppUrl).origin;
const defaultSessionHandle = localStorage.getItem("ehr/sessionHandle") || demoHandle;
const defaultCountdown = 5;
const resourceIds = new Map();
const sessionHandles = new Map();
function Ehr() {
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("{}");
  const [messageFromApp, setMessageFromApp] = useState("");
  const [appUrl, setAppUrl] = useState(defaultAppUrl);
  const [appOrigin, setAppOrigin] = useState(defaultAppOrigin);
  const [sessionHandle, setSessionHandle] = useState(defaultSessionHandle);
  const [scratchpad, setScratchpad] = useState(new Map());
  const [activity, setActivity] = useState({});
  const [countdown, setCountdown] = useState(defaultCountdown);
  const [client, setClient] = useState(null);
  useEffect(() => {
    if (client?.messagingHandle) {
      sessionHandles.delete(client.messagingHandle);
    }
    setClient(null);
    saveSessionHandle();
    console.debug("EHR: creating new swm client");
    const newClient = new swm.Client(sessionHandle, appOrigin);
    console.debug("EHR: enabling swm client");
    newClient.enable({
      receiveMessage: (message2) => {
        if (sessionHandles.has(message2.messagingHandle)) {
          setResponse(`Awaiting EHR action in response to the received '${message2?.messageType}' message...`);
          setMessage(message2);
          setMessageFromApp(JSON.stringify(message2, null, 2));
        } else if (message2.messagingHandle) {
          console.error(`Unknown messaging handle: ${message2.messagingHandle}`);
        }
      },
      receiveError: console.error
    });
    setClient(newClient);
    return () => {
      console.debug("EHR: disabling an old swm client");
      newClient.disable();
    };
  }, [sessionHandle, appOrigin]);
  useEffect(() => {
    const messageType = message.messageType || "";
    const autoReply = document.getElementById("auto-reply").checked;
    if (messageType === "ui.done") {
      showCountdown();
    } else if (messageType === "ui.launchActivity") {
      launchActivity();
    } else if (messageType.startsWith("scratchpad.")) {
      applyScratchpadMessage(autoReply);
    } else if (messageType === "status.handshake" && autoReply) {
      prepopulate(getHandshakeResponse());
    }
  }, [message]);
  useEffect(() => {
    if (document.getElementById("auto-send").checked && isResponseSendable()) {
      sendResponse();
    }
  }, [response]);
  useEffect(() => {
    if (countdown <= 0 && document.getElementById("app-closing").open) {
      closeApp();
    }
  }, [countdown]);
  function openConfig() {
    document.getElementById("config-panel").showModal();
  }
  function updateSessionHandle(e) {
    setSessionHandle(e.target.value);
  }
  function updateAppUrl(e) {
    const url = e.target.value;
    setAppUrl(url);
    try {
      if (new URL(url).origin !== appOrigin) {
        setAppOrigin(new URL(url).origin);
      }
    } catch {
    }
  }
  function closeConfig() {
    try {
      const url = new URL(appUrl);
      if (url.toString() !== appUrl) {
        console.warn(`appUrl is not normalized - saving as '${url.toString()}'`);
      }
      localStorage.setItem("ehr/appUrl", url.toString());
    } catch (e) {
      console.error(e);
    }
    localStorage.setItem("ehr/sessionHandle", sessionHandle);
    document.getElementById("config-panel").close();
  }
  function updateResponse(e) {
    setResponse(e.target.value);
  }
  function prepopulate(message2) {
    setResponse(JSON.stringify(message2, null, 2));
  }
  function getHandshakeResponse() {
    return client.createResponse(message);
  }
  function getUiDoneResponse(success) {
    return client.createResponse(message, {
      status: success && "success" || "failure",
      statusDetail: {
        text: `EHR ${success && "hid" || "did not hide"} the app iframe`
      }
    });
  }
  function getUiLaunchActivityResponse(success) {
    const activityType = message?.payload?.activityType;
    if (!activityType) {
      console.error("Missing activityType from message", message);
    }
    const status = success && "success" || "failure";
    return client.createResponse(message, {
      status,
      statusDetail: {
        text: `EHR completed activity "${activityType}" with status: ${status}`
      }
    });
  }
  function getScratchpadCreateResponse() {
    const resourceType = message.payload?.resource?.resourceType;
    if (!resourceType) {
      console.error("Unknown resourceType", message);
    }
    const id = 1 + (resourceIds.get(resourceType) || 0);
    resourceIds.set(resourceType, id);
    const location = `${resourceType}/${id}`;
    return client.createResponse(message, {
      status: "200 OK",
      location
    });
  }
  function getScratchpadReadResponse() {
    const location = message?.payload?.location;
    const status = !location || scratchpad.has(location) && "200 OK" || "404 NOT FOUND";
    const selected = [...scratchpad.entries()].filter((e) => !location || e[0] === location);
    return client.createResponse(message, {
      status,
      scratchpad: Object.fromEntries(selected)
    });
  }
  function getScratchpadDeleteResponse() {
    const location = message?.payload?.location ?? "Encounter/123";
    const status = scratchpad.has(location) && "200 OK" || "404 NOT FOUND";
    return client.createResponse(message, {status});
  }
  function getScratchpadUpdateResponse() {
    const location = message?.payload?.location ?? "Encounter/123";
    const status = scratchpad.has(location) && "200 OK" || "404 NOT FOUND";
    return client.createResponse(message, {status, location});
  }
  function copyResponseToClipboard() {
    navigator.clipboard.writeText(messageFromApp);
  }
  function isResponseSendable() {
    if (message && response)
      try {
        if (JSON.parse(response).responseToMessageId) {
          return true;
        }
      } catch (error) {
      }
    return false;
  }
  function sendResponse() {
    try {
      const r = JSON.parse(response);
      swm.checkIsObject(r);
      const window = sessionHandles.get(message.messagingHandle);
      if (!window) {
        console.error("Unknown session handle", sessionHandle);
      }
      client.sendResponse(r, window);
    } catch (e) {
      console.error("failed to send message", e);
    }
  }
  function applyScratchpadMessage(autoReply) {
    if (!message || !message.messageType?.startsWith("scratchpad.")) {
      console.error("unable to apply message of unknown type", message);
    }
    var reply = {};
    switch (message.messageType.replace("scratchpad.", "")) {
      case "create":
        reply = getScratchpadCreateResponse();
        setScratchpad(new Map(scratchpad).set(reply.payload.location, message.payload.resource));
        break;
      case "read":
        reply = getScratchpadReadResponse();
        break;
      case "update":
        reply = getScratchpadUpdateResponse();
        if (scratchpad.has(message.payload.location)) {
          setScratchpad(new Map(scratchpad).set(message.payload.location, message.payload.resource));
        }
        break;
      case "delete":
        reply = getScratchpadDeleteResponse();
        const copy = new Map(scratchpad);
        copy.delete(message.payload.location);
        setScratchpad(copy);
        break;
      default:
        console.error("unknown scratchpad operation", message);
    }
    if (autoReply) {
      prepopulate(reply);
    }
  }
  function closeApp() {
    document.getElementById("app-iframe").src = "";
    document.getElementById("app-closing").close();
    if (document.getElementById("auto-reply").checked) {
      prepopulate(getUiDoneResponse(true));
    }
    document.getElementById("reload-app").style.display = "block";
  }
  function reloadApp() {
    document.getElementById("app-iframe").src = appUrl;
    document.getElementById("reload-app").style.display = "none";
  }
  function launchActivity() {
    setActivity(message.payload);
    document.getElementById("activity-panel").showModal();
  }
  function closeActivity() {
    document.getElementById("activity-panel").close();
    if (document.getElementById("auto-reply").checked) {
      prepopulate(getUiLaunchActivityResponse(true));
    }
  }
  function cancelActivity() {
    if (document.getElementById("auto-reply").checked) {
      prepopulate(getUiLaunchActivityResponse(false));
    }
  }
  function saveSessionHandle() {
    sessionHandles.set(sessionHandle, document.getElementById("app-iframe").contentWindow);
  }
  function showCountdown() {
    document.getElementById("app-closing").showModal();
    setCountdown(defaultCountdown);
    var c = defaultCountdown;
    const i = setInterval(() => {
      setCountdown(--c);
    }, 1e3);
    setTimeout(() => {
      clearInterval(i);
    }, defaultCountdown * 1e3);
  }
  function cancelClose() {
    document.getElementById("app-closing").close();
    if (document.getElementById("auto-reply").checked) {
      prepopulate(getUiDoneResponse(false));
    }
  }
  function selectedResponse(e) {
    const responseGetters = {
      "status.handshake": getHandshakeResponse,
      "ui.done": getUiDoneResponse,
      "ui.launchActivity": getUiLaunchActivityResponse,
      "scratchpad.create": getScratchpadCreateResponse,
      "scratchpad.update": getScratchpadUpdateResponse,
      "scratchpad.delete": getScratchpadDeleteResponse
    };
    const selected = e.target.selectedOptions[0].label;
    prepopulate(responseGetters[selected]());
    e.target.selectedIndex = 0;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "Ehr"
  }, /* @__PURE__ */ React.createElement("header", {
    className: "Ehr-header"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "scratchpad-toggle"
  }, /* @__PURE__ */ React.createElement("button", {
    id: "scratchpad-toggle",
    onClick: () => {
      const contents = document.getElementById("scratchpad");
      const seen = contents.style.display !== "none";
      contents.style.display = seen && "none" || "block";
    }
  }, "Scratchpad"), /* @__PURE__ */ React.createElement("p", null, scratchpad.size, " Entries")), /* @__PURE__ */ React.createElement("p", null, "Mock EHR  ", /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    href: "https://build.fhir.org/ig/HL7/smart-web-messaging/"
  }, "SMART Web Messaging"), "  Demo App"), /* @__PURE__ */ React.createElement("button", {
    className: "config-button",
    onClick: openConfig
  }, "configure")), /* @__PURE__ */ React.createElement("main", {
    className: "Site-content"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ehr-main"
  }, /* @__PURE__ */ React.createElement("dialog", {
    className: "activity-panel",
    id: "activity-panel",
    onCancel: cancelActivity
  }, /* @__PURE__ */ React.createElement("h1", null, "Activity Launched from App"), /* @__PURE__ */ React.createElement("pre", null, JSON.stringify(activity, null, 2)), /* @__PURE__ */ React.createElement("button", {
    onClick: closeActivity
  }, "Close")), /* @__PURE__ */ React.createElement("dialog", {
    className: "config-panel",
    id: "config-panel"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-header"
  }, /* @__PURE__ */ React.createElement("div", null, "EHR Settings"), /* @__PURE__ */ React.createElement("button", {
    className: "close-config",
    onClick: closeConfig
  }, "Close")), /* @__PURE__ */ React.createElement("div", {
    className: "config-settings"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-field"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-label"
  }, /* @__PURE__ */ React.createElement("p", null, "Session Handle")), /* @__PURE__ */ React.createElement("div", {
    className: "config-text-value"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    value: sessionHandle,
    onChange: updateSessionHandle
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "config-field"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-label"
  }, /* @__PURE__ */ React.createElement("p", null, "App URL")), /* @__PURE__ */ React.createElement("div", {
    className: "config-text-value"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    value: appUrl,
    onChange: updateAppUrl
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "config-field"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-label"
  }, /* @__PURE__ */ React.createElement("p", null, "Auto-response")), /* @__PURE__ */ React.createElement("div", {
    className: "config-text-value"
  }, /* @__PURE__ */ React.createElement("input", {
    id: "auto-reply",
    type: "checkbox",
    defaultChecked: true
  }))))), /* @__PURE__ */ React.createElement("div", {
    className: "scratchpad"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ React.createElement("pre", {
    id: "scratchpad",
    style: {display: "none"}
  }, JSON.stringify(Object.fromEntries(scratchpad), null, 2)))), /* @__PURE__ */ React.createElement("div", {
    className: "message-panel"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "from-app"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement("i", null, "Read-only ")), "message ", /* @__PURE__ */ React.createElement("i", null, "received"), " from App:"), /* @__PURE__ */ React.createElement("textarea", {
    disabled: true,
    className: "App-message",
    value: messageFromApp,
    readOnly: true,
    spellCheck: false
  }), /* @__PURE__ */ React.createElement("button", {
    className: "copy-response",
    onClick: copyResponseToClipboard
  }, "Copy to clipboard")), /* @__PURE__ */ React.createElement("div", {
    className: "to-send"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "send-header"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement("i", null, "Editable ")), /* @__PURE__ */ React.createElement("i", null, "response"), " to send to App:"), /* @__PURE__ */ React.createElement("select", {
    disabled: !messageFromApp,
    id: "template",
    onChange: selectedResponse
  }, /* @__PURE__ */ React.createElement("option", {
    value: ""
  }, "Insert a response..."), /* @__PURE__ */ React.createElement("optgroup", {
    label: "status"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "status.handshake"
  }, "status.handshake")), /* @__PURE__ */ React.createElement("optgroup", {
    label: "ui"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "ui.done"
  }, "ui.done"), /* @__PURE__ */ React.createElement("option", {
    value: "ui.launchActivity"
  }, "ui.launchActivity")), /* @__PURE__ */ React.createElement("optgroup", {
    label: "scratchpad"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.create"
  }, "scratchpad.create"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.read"
  }, "scratchpad.read"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.update"
  }, "scratchpad.update"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.delete"
  }, "scratchpad.delete")))), /* @__PURE__ */ React.createElement("textarea", {
    id: "responseText",
    className: "App-message",
    value: response,
    onChange: updateResponse,
    spellCheck: false
  }), /* @__PURE__ */ React.createElement("span", {
    className: "send-controls"
  }, /* @__PURE__ */ React.createElement("label", {
    title: "Automatically SEND the response above when updated."
  }, /* @__PURE__ */ React.createElement("input", {
    type: "checkbox",
    id: "auto-send"
  }), "Auto-SEND"), /* @__PURE__ */ React.createElement("button", {
    className: "send-button",
    onClick: sendResponse,
    disabled: !isResponseSendable()
  }, "SEND"))))), /* @__PURE__ */ React.createElement("div", {
    className: "Embedded-app"
  }, /* @__PURE__ */ React.createElement("dialog", {
    onCancel: cancelClose,
    className: "app-closing",
    id: "app-closing"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "closing-controls"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "closing-timer"
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: cancelClose
  }, "Cancel"), /* @__PURE__ */ React.createElement("h1", null, "Closing App in ", countdown, " seconds...")), /* @__PURE__ */ React.createElement("button", {
    onClick: closeApp
  }, "Close Now"))), /* @__PURE__ */ React.createElement("iframe", {
    id: "app-iframe",
    src: appUrl,
    allow: "clipboard-write",
    onLoad: saveSessionHandle
  }), /* @__PURE__ */ React.createElement("button", {
    id: "reload-app",
    className: "reload-app",
    onClick: reloadApp
  }, "Reload"))), /* @__PURE__ */ React.createElement("footer", {
    className: "Ehr-footer"
  }, /* @__PURE__ */ React.createElement("p", null, "EHR Footer")));
}
export default Ehr;
